import buttonStyle from "./button";

const buttonBlue = {
  ...buttonStyle,
  backgroundColor: "#3E64AE",
  color: "white",
};

export default buttonBlue;



// WEBPACK FOOTER //
// ./src/assets/EnergyCompany/jss/button-blue.jsx